export const FILE_CHUNK_SIZE = 4096
